import { ClipboardCheckIcon, HelpCircleIcon, LandmarkIcon, ListChecksIcon, SearchCheckIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  purpose?: string;
  progression?: string[];
  closing?: string;
  value: string;
  pages: number;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Banco de 150 Actividades de Museología',
    description:
      'Un banco práctico listo para usar en clases, talleres, formación y museos. Actividades en patrimonio, colecciones, conservación, exposiciones, educación, gestión, públicos y tecnología.',
    purpose: 'Aprender haciendo',
    value: '$18.000 ARS',
    pages: 111,
    icon: ListChecksIcon,
  },
  {
    number: '02',
    title: 'Banco de 100 Casos Prácticos de Museología',
    description:
      'Presenta situaciones problemáticas para que el estudiante deba analizar, diagnosticar, priorizar, tomar decisiones, justificar y resolver problemas reales de museo. Incluye situaciones de patrimonio, colecciones, documentación, conservación, exposiciones, educación, gestión, públicos y tecnología.',
    purpose: 'Pensar como un profesional',
    value: '$15.000 ARS',
    pages: 100,
    icon: SearchCheckIcon,
  },
  {
    number: '03',
    title: 'Banco de 200 Preguntas, Consignas y Debates de Museología',
    description:
      'Organizado en grandes áreas: fundamentos, patrimonio, documentación, conservación, museografía, educación, gestión, públicos y tecnología. 200 preguntas y debates completos.',
    items: ['Para debatir', 'Pregunta clave', '¿Vos qué pensás?', 'Dos posturas', 'Desafío de argumentación', 'Pensamiento crítico'],
    value: '$13.000 ARS',
    pages: 73,
    icon: HelpCircleIcon,
  },
  {
    number: '04',
    title: 'Evaluaciones, Rúbricas y Trabajos Prácticos de Museología',
    description:
      'Sistema completo para evaluar los principales campos de la Museología, con respuestas orientativas docentes y evaluación final integradora.',
    items: [
      'Evaluaciones diagnósticas',
      'Opción múltiple',
      'Verdadero/falso justificado',
      'Respuestas breves',
      'Análisis de situaciones',
      'Trabajos prácticos',
      'Actividades integradoras',
      'Rúbricas',
      'Criterios de corrección',
    ],
    progression: ['Recordar', 'Comprender', 'Aplicar', 'Analizar', 'Decidir', 'Justificar'],
    value: '$16.000 ARS',
    pages: 91,
    icon: ClipboardCheckIcon,
  },
  {
    number: '05',
    title: 'Proyecto Integrador: creá un museo desde cero',
    description:
      'El gran proyecto final de todo el MEGAPACK. El estudiante construye un museo trabajando identidad, misión, colección, documentación, conservación, exposición, educación, gestión, públicos, comunidad, accesibilidad, tecnología, apertura y contingencias.',
    items: ['Plan de apertura de 90 días', 'Carpeta profesional del museo 2026'],
    progression: ['Imaginar', 'Definir', 'Coleccionar', 'Documentar', 'Conservar', 'Exhibir', 'Educar', 'Gestionar', 'Incluir', 'Innovar', 'Abrir'],
    value: '$20.000 ARS',
    pages: 52,
    icon: LandmarkIcon,
    wide: true,
  },
];
